export default function BgImg() {
  return (
    <div>
      <img
        src={process.env.PUBLIC_URL + "/images/canvas_image.jpg"}
        alt="bgimg"
        style={{
          minHeight: "100vh",
          opacity: 0.25,
          objectFit: "cover", // This ensures the image covers the entire space without distortion
        }}
      />
    </div>
  );
}
